<template>
    <router-view/>
</template>

<script setup lang="ts">
// 对齐 EB App.vue getLayoutThemeConfig：启动即写入主题 CSS 变量（含 primary-light-*）
// 否则登录页未进 layout，按钮 hover 使用空的 --prev-color-primary-light-3 会变成白底
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';

useCrmebThemeConfigStore().initTheme();
</script>
